<template>
  <div>
    <div class="d-flex align-center mb-2">
      <v-chip small label :color="statusColor" text-color="white" class="mr-2">
        <v-icon x-small left>{{ statusIcon }}</v-icon>
        {{ statusText }}
      </v-chip>
      <span class="text-caption grey--text text-truncate">{{ base }}</span>
      <v-spacer></v-spacer>
      <v-btn icon small :loading="state === 'checking'" title="Volver a verificar" @click="refresh">
        <v-icon small>mdi-refresh</v-icon>
      </v-btn>
    </div>
    <v-alert v-if="state === 'offline'" dense text type="error" class="text-caption mb-2">
      {{ error }}. Abre ApiCheck en este equipo (o revisa la URL en «Probar impresora») antes de imprimir.
    </v-alert>
    <v-combobox
      :value="value"
      :items="printers || []"
      :hint="printers ? '' : 'No se pudo leer la lista de impresoras: escribe el nombre exacto.'"
      :persistent-hint="!printers && state !== 'checking'"
      :error-messages="notInstalled ? 'Esta impresora no está instalada en este equipo.' : []"
      dense
      outlined
      label="Impresora"
      prepend-inner-icon="mdi-printer"
      @input="$emit('input', $event || '')"
      @change="$emit('input', $event || '')"
    ></v-combobox>
  </div>
</template>

<script>
// Estado del servicio de impresión (ApiCheck) + selección de impresora instalada.
// Emite `status` con { online, printerOk } para que el diálogo bloquee "Imprimir".
export default {
  name: "PrinterPicker",
  props: {
    value: { type: String, default: "" },
  },
  data: () => ({
    state: "checking", // checking | online | offline
    version: null,
    error: "",
    printers: null,
    base: "",
  }),
  computed: {
    notInstalled() {
      return this.state === "online" && Array.isArray(this.printers) && !!this.value && !this.printers.includes(this.value);
    },
    statusColor() {
      return { checking: "grey", online: "success", offline: "error" }[this.state];
    },
    statusIcon() {
      return { checking: "mdi-timer-sand", online: "mdi-check-circle", offline: "mdi-alert-circle" }[this.state];
    },
    statusText() {
      if (this.state === "checking") return "Verificando servicio…";
      if (this.state === "offline") return "Servicio apagado";
      return "Servicio listo" + (this.version ? ` · v${this.version}` : "");
    },
  },
  watch: {
    value() {
      this.emitStatus();
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh() {
      this.state = "checking";
      this.base = this.print_api_base();
      this.emitStatus();
      const health = await this.api_print_health();
      if (!health.online) {
        this.state = "offline";
        this.error = health.error;
        this.printers = null;
        this.emitStatus();
        return;
      }
      this.version = health.version;
      this.printers = await this.api_print_printers();
      this.state = "online";
      this.emitStatus();
    },
    emitStatus() {
      this.$emit("status", { online: this.state === "online", printerOk: !!this.value && !this.notInstalled });
    },
  },
};
</script>
